module.exports = __webpack_public_path__ + "static/Glider-cff9d086ced7675720f9366e1cbad7c0.gif";